import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n      background: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n      &:last-child {\n        ",
        "\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n      padding-top: 0;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n      padding-bottom: 0;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n\n  ",
        "\n\n    ",
        "\n\n    ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
import styled, { css } from "styled-components";
import Box from "./Box";
var SECTION_TYPES = {
    medium: {
        $py: [
            32,
            60
        ],
        paddingBottom: [
            64,
            120
        ]
    },
    large: {
        $py: [
            48,
            88
        ],
        paddingBottom: [
            48,
            88
        ]
    },
    minimal: {
        $py: 0,
        paddingBottom: 0
    }
};
// ! --offset-top-0 and --offset-bottom-0
var Section = styled(Box).attrs(function(_param) {
    var _type = _param.type, type = _type === void 0 ? "medium" : _type, props = _object_without_properties(_param, [
        "type"
    ]);
    var $py = SECTION_TYPES[type].$py;
    return _object_spread({
        $py: $py,
        as: "section"
    }, props);
}).withConfig({
    componentId: "sc-fe6c688-0"
})(_templateObject4(), function(param) {
    var background = param.background, theme = param.theme;
    return background && css(_templateObject(), theme.colors[background]);
}, function(param) {
    var theme = param.theme, _$withLastChildPadding = param.$withLastChildPadding, $withLastChildPadding = _$withLastChildPadding === void 0 ? true : _$withLastChildPadding, _type = param.type, type = _type === void 0 ? "medium" : _type;
    return $withLastChildPadding && css(_templateObject1(), theme.normalizeStyles({
        paddingBottom: SECTION_TYPES[type].paddingBottom
    }));
}, function(param) {
    var $noPaddingTop = param.$noPaddingTop;
    return $noPaddingTop && css(_templateObject2());
}, function(param) {
    var $noPaddingBottom = param.$noPaddingBottom;
    return $noPaddingBottom && css(_templateObject3());
});
export default Section;
